import { ref } from 'vue';
import useOrderDropdown from './useOrderDropdown';
import useSortSelection, { type SortSelectionSource } from './useSortSelection';

export type FilterAndSortEmit = {
  (e: 'update:sort', sort: string, order: string): void;
  (e: 'filter-clicked'): void;
};

export default function useFilterAndSort(
  emit: FilterAndSortEmit,
  sortSource?: SortSelectionSource | null
) {
  const isFilterActive = ref(false);

  const { selected, isSelected, select } = useSortSelection(sortSource);

  const {
    isOrderDropdownOpen,
    dropdownPosition,
    orderButtonRef,
    handleOrder,
    closeDropdown,
    handleClickOutside,
    hideModalOverlay,
  } = useOrderDropdown();

  const sortOptions = (sortCamp: string, orderFlow: string) => {
    const next = select(sortCamp, orderFlow);

    emit('update:sort', next.sort, next.order);
    closeDropdown();
  };

  const handleFilter = () => {
    emit('filter-clicked');
  };

  const setFilterActive = (active: boolean) => {
    isFilterActive.value = active;
  };

  return {
    isFilterActive,
    isOrderSelected: isSelected,
    isOrderDropdownOpen,
    selectedOption: selected,
    dropdownPosition,
    orderButtonRef,
    handleOrder,
    handleFilter,
    sortOptions,
    setFilterActive,
    handleClickOutside,
    hideModalOverlay,
  };
}
